import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { Observable } from 'rxjs';
import { SMSMessage } from '../_types/sms-message';

@Injectable({
  providedIn: 'root'
})
export class SMSMessageService extends Service<SMSMessage> {
  public override type = 'smsMessages';
  public override url = 'communications/smsMessages';
  

  public Send(smsMessage: SMSMessage): Observable<SMSMessage> {
    let url = this.getAPIUrl()+ '/send';    
    return this.http.post<SMSMessage>(url, smsMessage);
  }

}
